<p-sidebar
    [(visible)]="rightMenuActive"
    [position]="'right'"
    [baseZIndex]="1000"
    [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
>
    <ng-template pTemplate="headless">
        <div class="h-full py-4 px-3 pr-0">
            <div>
                <h5 class="mt-5 mx-3 mb-2 text-color opacity-80">
                   Consulti di oggi
                </h5>
                <ul class="py-5 m-0 p-0 list-none">
                    <li class="flex py-2 px-4">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="checked1"
                        ></p-checkbox>
                        <div class="ml-3">
                            <h6
                                class="m-0 text-color"
                                [ngClass]="{ 'line-through': checked1 }"
                            >
                               Consulto 1
                            </h6>
                            <span class="block text-sm text-color opacity-50"
                                >Oggi</span
                            >
                        </div>
                    </li>


                    <li class="flex py-2 px-4">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="checked4"
                        ></p-checkbox>
                        <div class="ml-3">
                            <h6
                                class="m-0 text-color"
                                [ngClass]="{ 'line-through': checked4 }"
                            >
                                Consulto 2
                            </h6>
                            <span class="block text-sm text-color opacity-50"
                                >Oggi</span
                            >
                        </div>
                    </li>
                </ul>
            </div>

            <hr />

            <div>
                <h5 class="mt-5 mx-3 mb-2 text-color opacity-80">Futuri</h5>
                <ul class="py-5 m-0 p-0 list-none">
                    <li class="flex py-2 px-4">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="checked5"
                        ></p-checkbox>
                        <div class="ml-3">
                            <h6
                                class="m-0 text-color"
                                [ngClass]="{ 'line-through': checked5 }"
                            >
                                Consulto 3
                            </h6>
                            <span class="block text-sm text-color opacity-50"
                                >12 gennaio</span
                            >
                        </div>
                    </li>
                    <li class="flex py-2 px-4">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="checked6"
                        ></p-checkbox>
                        <div class="ml-3">
                            <h6
                                class="m-0 text-color"
                                [ngClass]="{ 'line-through': checked6 }"
                            >
                                Consulto 4
                            </h6>
                            <span class="block text-sm text-color opacity-50"
                                >13 Febbraio</span
                            >
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </ng-template>
</p-sidebar>
